export default __webpack_public_path__ + "static/media/commonroad-io-code-example.15ce3052.md";